import { Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { HOME_DECOR_POINTS } from "../../../../utils/constants/svg.constants";
import { getRandomNumberInRange } from "../../../../utils/helpers";
import { style } from "./hero.style";

const HeroDecor = (props) => {
  const [isPointsHidden, setIsPointsHidden] = useState(true);
  const [activePoint, setActivePoint] = useState(null);
  const [isLinesActive, setIsLinesActive] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("bp992"));

  useEffect(() => {
    if (isMobile) return;

    const interval = setInterval(() => {
      const MIN = 0;
      const MAX = HOME_DECOR_POINTS.length - 1;
      const active = getRandomNumberInRange(MIN, MAX);
      setActivePoint(active);
    }, 2500);

    const timeout = setTimeout(() => {
      setIsLinesActive(true);
      setIsPointsHidden(false);
    }, 0);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const definePointClasses = useCallback(
    (index) => {
      // let classes = "home-hero__decor-point";
      const classes = [style.decor.point];
      if (!isPointsHidden) classes.push(style.decor.point.visible);
      if (index === activePoint) classes.push(style.decor.point.active);

      return classes;
    },
    [activePoint, isPointsHidden]
  );

  const defineLineClasses = () => {
    const classes = [style.decor.line];

    if (isLinesActive) classes.push(style.decor.line.active);

    return classes;
  };

  return (
    <svg width={727} height={727} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle opacity={0.6} cx={363.5} cy={363.5} r={363.5} fill="url(#a)" fillOpacity={0.9} />
      <Box component="g" sx={style.decor.option} opacity={0.6} filter="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.204 237.472 94.568 224l10.104 18.524h26.944l13.472-15.156 28.628 15.156-6.736 20.208c6.736 5.052 11.788 10.104 16.84 16.84l23.576-1.684 11.788 31.996-20.208 11.788c1.684 8.42 1.684 18.524 1.684 26.944l16.84 10.104-16.84 31.996-20.208-6.736c-5.052 6.736-11.788 14.819-18.524 20.208l1.684 18.524L133.3 434.5l-10.104-18.524c-8.42 1.684-15.829 1.347-25.26 0l-13.472 16.84-33.68-15.156 8.42-20.208c-6.736-5.052-11.114-10.104-15.156-16.84H20.472L7 348.616l18.524-11.788c0-8.42.337-15.829 1.684-25.26l-16.84-11.788 15.156-30.312 20.208 5.052c5.052-5.052 10.104-9.43 16.84-13.472l-3.368-23.576Zm53.888 131.352c21.391 0 38.732-17.341 38.732-38.732s-17.341-38.732-38.732-38.732c-21.39 0-38.732 17.341-38.732 38.732s17.341 38.732 38.732 38.732Z"
          fill="url(#c)"
          fillOpacity={0.14}
        />
      </Box>
      <Box component="g" sx={style.decor.option} opacity={0.6} filter="url(#d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M379.349 480.36 414.42 467l10.02 18.37h26.72l13.361-15.03 28.39 15.03-6.68 20.041c6.68 5.01 11.69 10.02 16.7 16.7l23.381-1.67 11.69 31.731-20.04 11.69c1.67 8.35 1.67 18.37 1.67 26.72l16.7 10.021-16.7 31.73-20.041-6.68c-5.01 6.68-11.69 14.696-18.37 20.04l1.67 18.371-30.06 11.69-10.021-18.37c-8.35 1.67-15.698 1.336-25.05 0l-13.36 16.7-33.401-15.03 8.35-20.041c-6.68-5.01-11.022-10.02-15.03-16.7h-23.381l-13.36-31.731 18.37-11.69c0-8.35.334-15.698 1.671-25.05l-16.701-11.691 15.03-30.06 20.041 5.01c5.01-5.01 10.02-9.352 16.7-13.36l-3.34-23.381Zm53.441 130.263c21.214 0 38.411-17.197 38.411-38.411 0-21.214-17.197-38.411-38.411-38.411-21.213 0-38.41 17.197-38.41 38.411 0 21.214 17.197 38.411 38.41 38.411Z"
          fill="url(#e)"
          fillOpacity={0.2}
        />
      </Box>
      <Box component="g" sx={style.decor.option} opacity={0.6} filter="url(#f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m442.054 157.434 41.977 6.758-.575 23.7 26.217 15.136 21.622-7.179 19.341 30.829-17.906 15.878c3.716 8.7 5.793 16.453 6.925 25.845l23.885 11.606-6.504 37.754-26.285.117c-3.091 9.139-8.767 18.97-13.497 27.162l10.709 19.292-34.359 21.671-15.878-17.906c-8.7 3.717-19.795 7.797-29.376 9.257l-8.768 18.969-36.115-5.558.575-23.7c-9.139-3.091-16.159-7.581-24.578-14.19l-22.568 8.818-24.256-33.667 19.544-14.932c-3.716-8.7-5.138-16.075-5.286-24.9l-22.94-13.244 4.866-38.7 24.646-1.063c4.73-8.193 9.22-15.213 15.828-23.632l-9.763-20.93 31.775-20.979 16.824 16.268c7.754-2.078 15.129-3.5 23.953-3.649l9.967-24.831Zm-21.353 158.078c20.814 12.016 47.428 4.885 59.444-15.928 12.017-20.814 4.886-47.428-15.928-59.444-20.813-12.017-47.427-4.886-59.444 15.928-12.016 20.813-4.885 47.427 15.928 59.444Z"
          fill="url(#g)"
          fillOpacity={0.3}
        />
      </Box>
      <g filter="url(#h)">
        <circle cx={289.153} cy={407.191} r={209.067} fill="url(#i)" />
        <g filter="url(#j)">
          <circle cx={289.33} cy={406.993} r={56.455} fill="url(#k)" />
        </g>
        <path
          d="M316.671 249.305c-1.159-.773-.483-2.897 0-3.863.966-1.931 1.449-4.346 3.38-4.346 1.931 0 5.794-1.448 8.208-1.931 2.414-.483 2.897 2.414 2.897 5.311s-1.448 3.863-2.414 3.863c-.966 0-5.311 1.448-7.243 2.414-1.931.966-3.379-.483-4.828-1.448Z"
          fill="url(#l)"
          fillOpacity={0.8}
        />
        <path
          d="M385.232 264.273c3.863.387 4.185 3.702 3.863 5.311 0 1.288-.29 4.443-1.449 6.76-1.448 2.897-5.311 4.828-6.759 6.76-1.449 1.931-7.726 3.862-12.071 2.897-4.346-.966-15.451-1.932-18.831-1.449-3.379.483-3.862 4.346-3.862 6.76 0 2.414-.483 3.863-2.415 5.794-1.931 1.931-5.311 3.863-8.691 5.311-3.379 1.449.483 3.863 1.932 5.311 1.448 1.449.483 4.829 0 7.726-.483 2.897-4.829.482-9.174 0-4.346-.483-7.725 3.379-11.588 5.794-3.863 2.414-2.414 9.656 0 11.105 2.414 1.448-3.38 3.38 0 4.345 3.38.966 3.863 1.449 7.725 2.415 3.863.965 6.277-1.932 8.208-2.415 1.932-.483 7.243-2.414 10.14-3.38 2.897-.965 4.346-7.242 5.311-9.173.966-1.932 11.105-2.897 16.417-2.897 5.311 0 11.105 7.725 12.07 11.105.966 3.38 5.794.965 8.209 0 2.414-.966 8.691-.483 14.967.965 6.277 1.449 14.968 5.795 20.279 8.209 5.312 2.414 5.312 4.345 3.38 7.242-1.931 2.897-7.725 3.38-10.622 4.829-2.897 1.448-7.725-1.449-11.588-1.449-3.863 0-7.725-2.414-11.105-3.863-3.38-1.448-8.691-.965-11.105 0-2.415.966-1.449 3.863-5.312 3.863-3.862 0-6.759-3.863-10.622-5.794-3.863-1.931-17.382-3.863-22.693-3.863s-10.14 1.932-15.934 4.829c-5.794 2.897-7.725 10.139-10.139 14.002-2.414 3.863-6.277 8.208-7.726 10.139-1.448 1.932-6.276 19.314-5.311 22.694.966 3.379-.965 6.759-5.311 8.691-4.345 1.931.966 10.622 4.346 14.485 3.38 3.862 7.242 18.347 14.002 24.624 6.76 6.277 14.002-1.931 14.968-3.38.965-1.448 1.931-3.38 6.277-.965 4.345 2.414 8.208 1.448 10.139 0 1.931-1.449 4.346-1.449 6.76 0 2.414 1.448 7.725 4.345 13.519 6.759 5.794 2.414 2.414 5.311 0 8.208-2.414 2.897-.966 8.209 4.346 17.382 5.311 9.174.965 18.831.965 22.211 0 3.38-2.897 14.002 1.932 18.348 4.828 4.345 9.656 14.967 12.553 20.761 2.897 5.794 3.38 12.071 10.14 20.279 6.759 8.209 21.727-4.828 23.176-8.208 1.448-3.38 14.002-11.588 14.002-16.899 0-5.311 1.448-10.622 6.277-17.382 4.828-6.76 5.311-19.796 3.862-23.659-1.448-3.863 0-15.451 0-18.83 0-3.38 8.209-14.485 10.623-18.348 2.414-3.863 11.588-19.313 14.002-24.142 2.414-4.828-3.863-1.931-7.242-1.931-3.38 0-14.485.483-18.831 0s-6.277-22.21-8.691-26.556c-2.414-4.345-10.622-16.416-11.588-17.865-.966-1.448-.966-5.794 2.897-9.656 3.863-3.863 7.242 2.414 10.139 6.276 2.897 3.863 4.829 13.037 4.829 17.865 0 4.829 7.725 9.657 10.139 11.105 2.415 1.449-2.414 5.312-2.414 9.174 0 3.863 6.76 3.38 8.691 3.38 1.932 0 4.829-3.38 6.76-3.38s7.725-4.345 10.139-5.794c2.415-1.448 8.209-7.725 9.657-9.174 1.449-1.448-.483-5.794-1.448-7.242-.966-1.449-7.726-6.76-11.588-7.725-3.863-.966-5.312-3.863-5.312-4.829 0-.965-.965-4.345-1.931-4.345-.966 0-.483-3.863.483-6.76s5.794-.966 7.725-.966c1.932 0 2.414 2.415 4.829 2.415 2.414 0 4.345.482 4.828 3.862.386 2.704 4.345 5.955 6.277 7.243 2.704 2.317 11.339 5.311 11.105 2.897-1.159-11.975-9.532-39.11-21.728-69.046-12.196-29.935-56.008-71.942-58.905-71.942-1.932 0-7.726-.965-11.588-1.448-3.863-.483-4.829.965-6.76.965s-4.828 0-5.794-1.448c-.966-1.449-6.76-3.863-10.622-3.863-3.863 0-9.174 1.449-11.588 2.897-2.415 1.449-6.76 1.449-9.657 2.897-2.897 1.449-2.414 4.829-1.931 6.76.482 1.931-1.449 5.311-3.38 6.277-1.932.965-1.932 1.931-2.414 3.38-.483 1.448-2.897 3.379-4.829 3.862-1.931.483-.965 2.897-.483 4.346.483 1.448-.482 2.897 0 4.345.483 1.449 3.863 2.897 5.312 3.38 1.448.483 3.862 1.449 6.759.966 2.897-.483 5.311-1.932 6.277-2.897.966-.966 4.346 0 5.794-1.932 1.449-1.931 1.449-1.931 2.897-1.448 1.449.483 2.897-.966 3.38-2.414.483-1.449 2.897-1.932 7.725-1.449Z"
          fill="url(#m)"
          fillOpacity={0.8}
        />
        <path
          d="M231.688 224.197c0-1.159 6.437-3.702 9.656-4.828 6.277-2.514 39.11-10.14 53.595-5.312 10.139 3.38 9.656 10.14 9.656 11.588 0 1.449-4.828 1.932-4.345 3.863.483 1.931-2.414 4.346-3.863 4.346-1.448 0-2.414 2.897-2.897 4.345-.483 1.449-10.139 7.243-11.588 7.725-1.448.483-13.519 8.209-16.899 10.14-3.38 1.931-12.071 10.622-16.416 12.071-4.346 1.448-4.346-3.863-4.346-6.277s-2.414-4.346-3.862-4.346c-1.449 0-1.449-8.208-1.932-9.656-.483-1.449 1.449-1.932 2.897-1.932 1.449 0 2.897-2.897 3.38-4.345.483-1.449-.483-3.38-3.38-3.863-2.897-.483-2.414-1.931-2.897-3.862-.483-1.932-.965-1.449-3.38-1.932-2.414-.483-.965-2.414-.965-3.862 0-1.449-2.414-2.415-2.414-3.863Z"
          fill="url(#n)"
          fillOpacity={0.8}
        />
        <path
          d="M322.468 297.588c-1.159-1.159 1.77-3.38 3.379-4.346 3.38-.965 3.863-6.276 4.346-8.208.483-1.931 1.448-1.448 1.448-2.897 0-1.448 0-5.794-.965-6.759-.966-.966.483-3.863.965-4.829.483-.965 4.346 2.414 5.794 2.414 1.449 0 3.38 4.346 4.346 5.312.966.965.966 6.276.966 8.691 0 2.414-3.863 5.311-5.312 6.276-1.448.966-3.379 4.346-4.345 4.346-.773 0-5.15.966-7.243 1.448-.643 0-2.221-.289-3.379-1.448Z"
          fill="url(#o)"
          fillOpacity={0.8}
        />
        <path
          d="M197.894 228.06c-3.476-1.159-5.633-4.668-6.277-6.277 3.477-3.477 25.268-11.105 35.73-14.485.644.161 1.931 1.352 1.931 4.828 0 4.346-4.828 7.726-6.277 8.691-1.448.966-.965 3.863-1.931 2.897-.966-.965-1.931 0-6.277 2.414-4.345 2.415-12.553 3.38-16.899 1.932Z"
          fill="url(#p)"
          fillOpacity={0.8}
        />
        <path
          d="M175.684 252.202c3.862-3.863.965-15.451-1.449-18.348-2.414-2.897-43.455 25.59-73.39 80.633-16.828 30.941-19.314 66.631-19.314 73.874 0 7.242 3.38 10.622 8.691 14.968 5.311 4.345 19.796 14.485 24.142 16.416 4.345 1.931 13.519 10.622 16.416 14.002 2.897 3.38 20.279 1.449 20.762 9.174.483 7.725-14.485 21.728-13.519 38.144.965 16.416 18.348 28.487 26.556 34.764 8.208 6.277 4.828 21.245 7.242 36.213 2.414 14.967 15.934 29.452 20.762 34.281 4.828 4.828 32.35 16.416 37.178 17.382 4.829.965 5.311-4.346 4.346-5.794-.966-1.449-1.449-3.863-.966-5.794.483-1.932-10.139-13.037-14.002-15.451-3.863-2.414-4.828-5.794-5.794-8.208-.966-2.414-1.931-14.002-1.931-14.968 0-.966 2.414 0 5.311-8.691s7.725-13.519 10.139-14.968c2.414-1.448 11.105-6.759 12.554-12.553 1.448-5.794 9.174-21.728 12.071-26.556 2.897-4.829 2.414-12.071 2.414-15.451 0-3.38-8.208-7.243-11.105-8.208-2.897-.966-9.657 1.931-12.554-2.414-2.897-4.346-24.624-22.694-26.556-24.625-1.931-1.931-7.242 1.449-10.139-4.828-2.897-6.277-13.52-10.14-15.451-8.691-1.931 1.448-5.794-1.932-7.242-5.794-1.449-3.863-6.76-6.277-8.209-4.346-1.448 1.932-15.933 11.105-18.83 12.554-2.897 1.448-5.794-3.863-8.208-7.243-2.415-3.379-8.209-11.105-10.14-12.553-1.931-1.449-.483-4.346 0-13.037s-2.414-7.242-10.139-7.725c-7.726-.483-10.14-7.243-10.623-8.691-.483-1.449 2.414-4.346 3.38-5.794.966-1.449 4.828-.966 6.277-1.449 1.448-.483-.483-2.897 1.931-3.38 2.414-.482 2.897 0 5.794-1.448 2.897-1.449 9.657-2.414 13.52-2.414 3.862 0 7.242 3.862 9.656 4.345 2.414.483 3.863-4.345 3.863-10.622s5.794-7.725 10.622-9.657c4.829-1.931 4.829-10.622 5.794-12.071.966-1.448.483-4.828.966-5.794.483-.965 3.863-.965 6.277-.965s3.38-1.449 3.38-2.897c0-1.449 3.862-.483 5.311-1.449 1.448-.965-.483-2.897-.966-3.862-.483-.966 2.414-3.38 5.794-5.312 3.38-1.931 14.485-3.379 17.865-4.345 3.38-.966-1.448-4.828-2.414-7.243-.966-2.414-3.863-5.794-4.828-6.759-.966-.966.965-2.414 2.897-4.346 1.931-1.931 6.276-4.345 9.173-3.38 2.897.966 6.277.483 8.691.483 2.415 0 4.346-.965 4.346-2.897 0-1.931-6.277-3.38-8.208-3.38-1.932 0-1.932-1.931-.966-3.379.966-1.449-1.931-1.449-4.828-2.897-2.897-1.449 6.277-22.694 7.242-23.176.966-.483 1.932-2.415 5.311-1.449 3.38.966 3.38-2.414 7.243-5.311 3.863-2.897-3.38-4.828-4.828-4.828-1.449 0 0-4.346-1.449-4.829-1.448-.483-4.828-.966-5.794-3.38-.966-2.414-9.174-1.448-13.519-1.448-4.346 0-5.794 1.931-7.243 2.414-1.448.483-2.897-.483-2.897-1.931 0-1.449-5.311-.483-7.242-.483-1.932 0-1.449 11.105-1.449 13.519 0 2.414-.965 3.863-2.897 5.311-1.931 1.449.483 3.863 2.414 4.346 1.932.483 5.312-4.346 5.794-5.794.483-1.449 1.932-2.414 2.897-2.897.966-.483.966-6.277 2.415-4.828 1.448 1.448 5.311 1.931 8.208 2.414 2.897.483-.483 14.002-5.311 16.899-4.829 2.897-9.657 7.242-11.106 8.691-1.158 1.159-2.736 5.311-3.379 7.242-.773 3.091-5.312 6.277-7.243 7.726-2.704 1.545-7.082-.966-8.691-2.897-1.931-2.318-8.691-5.794-11.588-7.243-3.863-1.931-5.794-4.345-4.828-6.277 2.414-4.828 21.244-14.002 25.59-18.347Z"
          fill="url(#q)"
          fillOpacity={0.8}
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M170.222 490.391c-.644-14.485 2.414-47.221 19.796-62.286m-19.796 62.286c26.556 35.247 53.486 25.59 53.112 28.004m-53.112-28.004c-27.039-18.541-36.696-57.618-38.144-74.839m38.144 74.839c-30.901 1.159-55.687-13.68-64.217-21.245m64.217 21.245c-2.897 22.21 5.601 53.788 18.347 64.217m1.449-126.503c12.554-11.105 78.219-20.279 128.434-53.111m-128.434 53.111c1.449 18.831 10.526 56.685 33.316 90.29m-33.316-90.29c2.092-16.899 14.678-55.429 50.215-80.15m-50.215 80.15c-25.88-16.223-37.178-69.206-39.592-93.669m39.592 93.669c17.382 24.625 43.857 52.147 40.558 32.35m87.876-85.461c10.139-7.243 36.212-25.108 41.524-26.073m-41.524 26.073c10.429 20.858 45.386 40.075 61.803 44.156m-61.803-44.156c0 23.176 2.897 34.764 6.76 50.697m-6.76-50.697c-8.277-11.588-73.874-30.062-78.219-27.039m119.743.966c5.311-.966 8.208-18.831 35.729-41.524m-35.729 41.524c0-28.487-19.314-50.698-27.522-59.389m27.522 59.389c8.432.965 29.044 4.249 44.033 9.656m-44.033-9.656c7.684 15.772 22.919 51.47 22.389 68.079m-22.389-68.079c-84.014-26.556-173.338-26.073-209.55-14.485m245.279-27.039c4.829-3.38 13.52 28.487 8.691 49.249a35.043 35.043 0 0 0-.387 1.931m-8.304-51.18c-8.047-5.472-31.963-16.706-63.251-17.865m63.251 17.865c0-1.236.33-3.57 1.449-5.524m-173.82 216.522c-3.477 22.404-18.187 37.34-25.108 42.007 39.955-15.437 131.57-90.612 180.097-139.305m-154.989 97.298c41.04 30.419 127.468 29.453 173.82 21.728m-173.82-21.728c6.598-12.714 17.285-42.103 7.242-57.94m-7.242 57.94c36.695 0 87.586-45.579 101.878-92.704m-101.878 92.704c52.628 2.254 160.687-.676 171.888-30.418m1.932 52.146c21.244-6.76 42.155-57.94 43.938-69.528.772-5.022 1.287-31.062 1.448-43.455m-45.386 112.983c36.04-6.007 63.573-28.31 78.529-59.871m.173-123.606c-4.507-6.599-16.224-21.631-27.039-28.97m27.039 28.97c-2.414 37.178-30.902 69.045-33.316 70.494m33.316-70.494c17.416 46.029 15.729 90.05-.173 123.606m-26.866-152.576c2.414 6.277 6.277 69.528-4.828 87.393-5.794 9.174-3.863 13.519-1.449 12.071m6.277-99.464c-.161-11.266-4.345-37.082-19.796-50.215-3.38 1.932-26.556 19.796-29.936 22.211M442.54 427.14c-5.311 20.762-33.798 56.588-47.318 60.837m47.318-60.837c11.151 14.646 33.392 45.772 33.143 53.112M442.54 427.14c-.893-14.324-9.895-47.801-38.759-67.114m38.759 67.114c-12.133 1.111-41.577 1.069-62.285-7.99m14.967 68.827c-28.487-3.863-59.581-37.565-70.01-62.286m70.01 62.286c2.051-14.646 2.351-49.346-12.857-70.977m21.416-56.974c-1.884 13.171-.395 34.889-16.767 52.146a464.504 464.504 0 0 1-4.649 4.828m21.416-56.974c.071-.495.146-.978.228-1.449m0 0c11.524-8.852 39.513-28.101 45.384-28.487m-50.308-30.418c0-7.726-16.899-58.906-24.625-55.043-6.18 3.09-30.579 31.223-42.006 44.903m66.631 10.14c-.816.583-1.448 1.356-1.931 2.201m-64.7-12.341c-60.354-26.073-119.26-14.968-129.882-12.554m129.882 12.554c-27.522 6.277-70.977 25.204-92.221 58.423m92.221-58.423c-3.476-18.541-29.936-52.146-59.871-67.114m59.871 67.114c3.09-11.202-3.541-34.603-7.243-44.903M382.365 417c-.693.71-1.397 1.427-2.11 2.15m2.11-2.15c0 87.393-123.785 145.816-184.139 145.816M380.255 419.15c-.636.644-1.28 1.293-1.932 1.947m0 0c-6.92 3.712-27.232 9.827-53.111 4.594m0 0c-42.651-13.197-137.318-49.925-174.786-91.255m0 0c11.201-27.425 39.431-49.732 52.146-57.458m-52.146 57.458c-7.082 6.116-20.666 29.356-18.348 73.39.279 5.312.966 6.996 0 7.726m18.348-81.116c-17.769 1.158-45.065 17.221-56.492 25.107m146.299-11.588c-10.623-16.416-33.026-53.595-37.661-70.977m37.661 70.977c-1.932-46.352 12.65-93.477 32.35-125.537m-32.35 125.537c-5.472 23.981-15.065 80.054-9.657 112.5m-28.004-183.477c19.313-27.811 37.661-43.455 70.011-54.56m0 0c-4.829 0 36.212 8.208 52.628 22.211M132.078 415.552c-7.243 5.472-22.597 23.852-26.073 53.594m26.073-53.594c-23.176-11.588-35.086-42.168-38.144-56.009m12.071 109.603c-1.016 8.691-21.728-58.423-12.07-109.603m303.219-57.67c-9.657-15.721-42.366-47.201-71.943-57.244m0 0c5.151-3.219 21.535-8.305 45.87-2.897 24.334 5.407-20.44 4.184-45.87 2.897Z"
          stroke="#EDF4FF"
          strokeOpacity={0.15}
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M246.173 192.33c-8.852-1.77-28.858 2.698-35.73 35.247-18.347 86.91 5.312 277.147 96.084 379.025 9.465 10.622 25.591 22.21 48.284 10.622"
          stroke="url(#r)"
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M130.781 254.133c2.093-7.564 22.211-23.562 85.945-27.039 89.324-4.872 260.247 19.314 275.698 81.116"
          stroke="url(#s)"
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M141.401 250.753c-15.451-2.736-47.704-2.607-53.112 19.796-6.76 28.004 45.387 124.571 174.303 211.481 128.917 86.91 225.001 112.018 234.175 49.732"
          stroke="url(#t)"
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M105.67 541.419c-4.668 20.601-1.084 54.552 54.56 37.661 108.154-32.833 346.191-252.04 313.359-338.467-5.294-13.934-36.213-11.588-55.043 0"
          stroke="url(#u)"
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M258.247 197.641c15.772-6.276 55.236-12.553 86.91 12.554 39.592 31.384 66.631 92.221 68.562 143.885 2.979 79.667-14.485 160.783-55.043 212.929-36.427 46.835-77.543 65.376-121.191 58.423-16.899-2.692-39.496-15.933-48.766-31.384"
          stroke="url(#v)"
        />
        <Box component="path"
          sx={defineLineClasses()}
          d="M86.843 503.275c-11.428 9.495-20.859 31.963 32.832 45.869 82.082 21.258 308.531 8.691 371.299-52.146"
          stroke="url(#w)"
        />

        {HOME_DECOR_POINTS.map((point, i) => (
          <Box component="path" key={i} sx={definePointClasses(i)} d={point.d} fill={point.fill} />
        ))}
      </g>
      <defs>
        <linearGradient id="a" x1={-73} y1={389} x2={670} y2={363} gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="c"
          x1={113.092}
          y1={224}
          x2={113.092}
          y2={434.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2052CF" stopOpacity={0.35} />
          <stop offset={0.214} stopColor="#2052CF" stopOpacity={0.3} />
          <stop offset={0.565} stopColor="#2052CF" stopOpacity={0.25} />
          <stop offset={1} stopColor="#2052CF" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="e"
          x1={432.79}
          y1={467}
          x2={432.79}
          y2={675.754}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2052CF" stopOpacity={0.35} />
          <stop offset={0.214} stopColor="#2052CF" stopOpacity={0.3} />
          <stop offset={0.565} stopColor="#2052CF" stopOpacity={0.25} />
          <stop offset={1} stopColor="#2052CF" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="g"
          x1={502.055}
          y1={174.598}
          x2={383.805}
          y2={379.413}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2052CF" stopOpacity={0.35} />
          <stop offset={0.214} stopColor="#2052CF" stopOpacity={0.3} />
          <stop offset={0.565} stopColor="#2052CF" stopOpacity={0.25} />
          <stop offset={1} stopColor="#2052CF" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="i"
          x1={289.153}
          y1={198.124}
          x2={289.153}
          y2={616.259}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E9FF5" />
          <stop offset={0.151} stopColor="#6E95F9" />
          <stop offset={0.281} stopColor="#5D89FB" />
          <stop offset={0.422} stopColor="#4F7FFC" />
          <stop offset={0.545} stopColor="#3A6EF3" />
          <stop offset={0.719} stopColor="#2B63F2" />
          <stop offset={0.839} stopColor="#1E54DF" />
          <stop offset={1} stopColor="#1F4EC6" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={289.33}
          y1={350.537}
          x2={289.33}
          y2={463.448}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F1FF" />
          <stop offset={1} stopColor="#ABCDF5" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={323.594}
          y1={239.112}
          x2={323.594}
          y2={251.072}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="m"
          x1={395.28}
          y1={235.303}
          x2={395.28}
          y2={554.228}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="n"
          x1={268.143}
          y1={212.489}
          x2={268.143}
          y2={268.381}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="o"
          x1={332.475}
          y1={270.376}
          x2={332.475}
          y2={299.036}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="p"
          x1={210.448}
          y1={207.298}
          x2={210.448}
          y2={228.74}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="q"
          x1={167.732}
          y1={233.653}
          x2={167.732}
          y2={603.821}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2F0FF" stopOpacity={0.9} />
          <stop offset={0.214} stopColor="#C2F0FF" stopOpacity={0.75} />
          <stop offset={0.565} stopColor="#C2F0FF" stopOpacity={0.62} />
          <stop offset={1} stopColor="#C2F0FF" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={279.741}
          y1={192}
          x2={279.741}
          y2={622.048}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={311.603}
          y1={226.487}
          x2={311.603}
          y2={308.21}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={292.239}
          y1={249.541}
          x2={292.239}
          y2={566.315}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={290.436}
          y1={231.022}
          x2={290.436}
          y2={583.642}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={301.381}
          y1={192.027}
          x2={301.381}
          y2={626.847}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={284.487}
          y1={496.998}
          x2={284.487}
          y2={558.756}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.12} />
          <stop offset={0.5} stopColor="#F6F8FB" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={202.24}
          y1={248.34}
          x2={202.24}
          y2={281.173}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="y"
          x1={149.13}
          y1={305.315}
          x2={149.13}
          y2={338.148}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="z"
          x1={167.958}
          y1={466.581}
          x2={167.958}
          y2={493.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="A"
          x1={322.463}
          y1={219.371}
          x2={322.463}
          y2={248.341}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="B"
          x1={428.688}
          y1={244.478}
          x2={428.688}
          y2={281.174}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={393.44}
          y1={457.89}
          x2={393.44}
          y2={493.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="D"
          x1={218.657}
          y1={201.989}
          x2={218.657}
          y2={219.371}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={125.953}
          y1={270.551}
          x2={125.953}
          y2={287.933}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="F"
          x1={131.743}
          y1={402.847}
          x2={131.743}
          y2={420.229}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={187.758}
          y1={414.436}
          x2={187.758}
          y2={431.818}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="H"
          x1={232.18}
          y1={456.925}
          x2={232.18}
          y2={474.307}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={194.516}
          y1={549.629}
          x2={194.516}
          y2={567.011}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="J"
          x1={92.153}
          y1={345.873}
          x2={92.153}
          y2={365.186}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={272.735}
          y1={208.748}
          x2={272.735}
          y2={226.13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="L"
          x1={373.161}
          y1={228.062}
          x2={373.161}
          y2={247.375}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={316.672}
          y1={355.53}
          x2={316.672}
          y2={378.706}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="N"
          x1={221.066}
          y1={501.345}
          x2={221.066}
          y2={522.59}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={383.305}
          y1={400.916}
          x2={383.305}
          y2={424.092}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={438.822}
          y1={409.607}
          x2={438.822}
          y2={431.818}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={447.518}
          y1={311.109}
          x2={447.518}
          y2={332.354}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="R"
          x1={396.338}
          y1={288.899}
          x2={396.338}
          y2={310.144}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="S"
          x1={332.602}
          y1={276.345}
          x2={332.602}
          y2={293.727}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="T"
          x1={403.094}
          y1={345.873}
          x2={403.094}
          y2={363.255}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="U"
          x1={356.743}
          y1={337.182}
          x2={356.743}
          y2={354.564}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="V"
          x1={323.914}
          y1={412.505}
          x2={323.914}
          y2={429.887}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={395.375}
          y1={526.452}
          x2={395.375}
          y2={543.834}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <linearGradient
          id="X"
          x1={474.555}
          y1={342.01}
          x2={474.555}
          y2={359.393}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F6FE" />
          <stop offset={1} stopColor="#BFCCED" />
        </linearGradient>
        <filter
          id="b"
          x={7}
          y={224}
          width={212.188}
          height={215.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.0729167 0 0 0 0 0.226987 0 0 0 0 0.625 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_1051_14955" />
        </filter>
        <filter
          id="d"
          x={327.578}
          y={467}
          width={210.422}
          height={213.754}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.0729167 0 0 0 0 0.226987 0 0 0 0 0.625 0 0 0 0.1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_1051_14955" />
        </filter>
        <filter
          id="f"
          x={323.961}
          y={157.434}
          width={239.578}
          height={243.889}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.0729167 0 0 0 0 0.226987 0 0 0 0 0.625 0 0 0 0.15 0" />
          <feBlend in2="shape" result="effect1_innerShadow_1051_14955" />
        </filter>
        <filter
          id="h"
          x={47.5}
          y={156.5}
          width={474.719}
          height={513.848}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={-3} dy={16} />
          <feGaussianBlur stdDeviation={13.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.460833 0 0 0 0 0.516133 0 0 0 0 0.658333 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1051_14955" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-15} />
          <feGaussianBlur stdDeviation={10} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.478264 0 0 0 0 0.510325 0 0 0 0 0.591667 0 0 0 0.1 0" />
          <feBlend in2="effect1_dropShadow_1051_14955" result="effect2_dropShadow_1051_14955" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1051_14955" result="shape" />
        </filter>
        <filter
          id="j"
          x={102.875}
          y={220.537}
          width={372.914}
          height={372.911}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={65} result="effect1_foregroundBlur_1051_14955" />
        </filter>
      </defs>
    </svg>
  );
};

export default HeroDecor;
